<template>
  <div :class="{ colorCard: true, active: isActive }" @click="selectColor">
    <div class="colorCard-img">
      <img :src="defaultImg" alt="Cor interior do carro" />
    </div>
    <p class="colorCard-content">{{ colorDesignation }}</p>
  </div>
</template>
<script>
import { mapMutations, mapState } from "vuex";
import { cookiesFunc } from "../../../mixins/cookiesFunc";

export default {
  name: "ColorCard",
  props: {
    isActive: { type: Boolean, default: false },
    colorImg: { type: String },
    colorDesignation: { type: String },
    factoryCode: { type: String },
    colorId: { type: [String, Number] },
    colorPrice: { type: [String, Number], default: "0.00" },
  },
  inject: ["page", "isExtColor"],
  mixins: [cookiesFunc],
  data() {
    return {
      defaultImg: !this.isExtColor
        ? require("@/assets/img/intDesignIcon.webp")
        : require("@/assets/img/nophotos.webp"),
    };
  },
  mounted() {
    let colImg = this.colorImg;
    if (colImg) {
      this.defaultImg = colImg;
    }
    if (this.isActive) this.saveColor();
  },
  computed: {
    ...mapState(["resumeData"]),
  },
  methods: {
    ...mapMutations({
      updateColor: "resumeData/UPDATE_CONFIGOPTIONS",
      updateResumeState: "resumeData/UPDATE_STATE",
    }),
    selectColor() {
      this.saveColor();
      this.$emit("color-selected", this.colorId);
    },
    saveColor() {
      const img = this.colorImg || this.defaultImg;
      let obj = null;
      let route = "";
      let runSaveStepFn = null;

      if (this.page === "Exterior") {
        route = "Exterior";
        runSaveStepFn = () => this.saveCookieCfgSteps(3);
      } else if (this.page === "Interior") {
        route = "Interior";
        runSaveStepFn = () => this.saveCookieCfgSteps(4);
      }

      if (route) {
        obj = {
          [`dsg${route.slice(0, 3)}`]: {
            label: `Design ${this.page}`,
            colorImg: img,
            designation: this.colorDesignation,
            route: `Design${route}`,
            price: this.colorPrice,
            colorid: this.colorId,
            factoryCode: this.factoryCode,
          },
        };

        setTimeout(runSaveStepFn, 1);
        this.updateColor(obj);
      }
    },
  },
};
</script>
<style lang="scss">
@import "./ColorCard.scss";
</style>
